const ANALYTICS_COOKIES = [/^_ga$/, /^_ga_/, /^_gid$/, /^_gat/];
const MARKETING_COOKIES = [/^_gcl_/, /^_gac_/];

/**
 * Cookie-attribute suffixes to try when deleting: host-only, the exact host,
 * and the parent domain. The last-two-labels rule assumes single-label public
 * suffixes (true for .com/.us/.uk/.eu/.fitness).
 */
export function cookieDomainsFor(hostname: string): string[] {
  const labels = hostname.split(".");
  return [
    "",
    `; Domain=${hostname}`,
    ...(labels.length >= 2 ? [`; Domain=.${labels.slice(-2).join(".")}`] : []),
  ];
}

/**
 * Delete Google cookies for categories the visitor has turned off. Consent
 * Mode stops tags writing new cookies but leaves existing ones; the UK ICO
 * expects withdrawal to remove them. Tries host-only and the registrable
 * domain (Google sets `_ga` on `.tongkatfitness.com`).
 */
export function clearGoogleCookies(off: {
  analytics: boolean;
  marketing: boolean;
}): string[] {
  const patterns = [
    ...(off.analytics ? ANALYTICS_COOKIES : []),
    ...(off.marketing ? MARKETING_COOKIES : []),
  ];
  if (patterns.length === 0) return [];

  try {
    const names = document.cookie
      .split(";")
      .map((part) => part.trim().split("=")[0])
      .filter((name) => name && patterns.some((p) => p.test(name)));

    const domains = cookieDomainsFor(window.location.hostname);
    for (const name of names) {
      for (const domain of domains) {
        // biome-ignore lint/suspicious/noDocumentCookie: deleting Google cookies on consent withdrawal
        document.cookie = `${name}=; Path=/; Max-Age=0${domain}`;
      }
    }
    return names;
  } catch {
    return [];
  }
}
